import { ratingChips } from '../lib/ratings';

/** IMDb, Rotten Tomatoes, Metacritic and TMDb, as the API sends them for films and series. */
export function RatingChips({ ratings }: { ratings: unknown }) {
  const chips = ratingChips(ratings);
  if (!chips.length) return null;
  return (
    <div className="rating-chips">
      {chips.map((chip) => (
        <span key={chip.key} className={`rating-chip rating-${chip.key}`} title={chip.votes ? `${chip.label}: ${chip.score} · ${chip.votes}` : `${chip.label}: ${chip.score}`}>
          <b>{chip.label}</b> {chip.score}{chip.votes ? <small>{chip.votes}</small> : null}
        </span>
      ))}
    </div>
  );
}
